import { render, staticRenderFns } from "./SpotTrade.vue?vue&type=template&id=0fc8a655&scoped=true"
import script from "./SpotTrade.vue?vue&type=script&lang=js"
export * from "./SpotTrade.vue?vue&type=script&lang=js"
import style0 from "./SpotTrade.vue?vue&type=style&index=0&id=0fc8a655&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc8a655",
  null
  
)

export default component.exports